import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { DriverReviewsService } from "./driver-reviews.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
@Component({
  selector: "app-driver-reviews",
  templateUrl: "./driver-reviews.component.html",
  styleUrls: ["./driver-reviews.component.sass"],
})
export class DriverReviewsComponent implements OnInit {
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private driverReviewsService: DriverReviewsService,
    public activatedRoute: ActivatedRoute
  ) {}
  allReviews: [];
  id: "";
  itemsPerPage: Number;
  totalItems: number = 0;
  page: Number = 1;
  phoneNumber: "";
  name: "";
  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.queryParams.id;
    this.name = this.activatedRoute.snapshot.queryParams.name;
    this.phoneNumber = this.activatedRoute.snapshot.queryParams.phoneNumber;
    this.driverReviews(1);
  }

  driverReviews(page: number) {
    this.spinner.show();
    let data = {
      driverId: this.id,
      page: page,
      limit: 6,
    };
    this.driverReviewsService
      .getDriverReviews(data)
      .subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.allReviews = result.data;
          this.totalItems = result.pagination?.total;
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
      });
  }

  handleBack() {
    this.router.navigate(["/dashboard/drivers"], {});
  }
}